import { LayoutList, Rows3 } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { WorkspaceDensity } from "./use-workspace-density";

export function DensityToggle({
  density,
  onChange,
}: {
  density: WorkspaceDensity;
  onChange: (density: WorkspaceDensity) => void;
}) {
  return (
    <ToggleGroup
      type="single"
      variant="outline"
      size="sm"
      value={density}
      aria-label="Row density"
      className="gap-0"
      onValueChange={(value) => {
        // Radix reports an empty value when the active item is pressed again.
        if (value) {
          onChange(value as WorkspaceDensity);
        }
      }}
    >
      <ToggleGroupItem
        value={WorkspaceDensity.Standard}
        aria-label="Standard rows"
        className="rounded-r-none"
      >
        <Rows3 className="size-4" aria-hidden="true" />
      </ToggleGroupItem>
      <ToggleGroupItem
        value={WorkspaceDensity.Compact}
        aria-label="Compact rows"
        className="rounded-l-none"
      >
        <LayoutList className="size-4" aria-hidden="true" />
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
